package tta.destinigo.talktoastro.core.navigation_decompose

import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.DelicateDecomposeApi
import com.arkivanov.decompose.router.slot.SlotNavigation
import com.arkivanov.decompose.router.slot.activate
import com.arkivanov.decompose.router.slot.dismiss
import com.arkivanov.decompose.router.stack.StackNavigation
import com.arkivanov.decompose.router.stack.pop
import com.arkivanov.decompose.router.stack.popTo
import com.arkivanov.decompose.router.stack.popToFirst
import com.arkivanov.decompose.router.stack.popWhile
import com.arkivanov.decompose.router.stack.push
import com.arkivanov.decompose.router.stack.pushNew
import com.arkivanov.decompose.router.stack.replaceCurrent
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import tta.destinigo.talktoastro.bottom_navigation.BottomNavigationComponent
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.AboutUsConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ArticleDetailPageConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ArticleListPageConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.BottomNavigationConfiguration
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ChatHistory
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ChoseRechargePage
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ContactUsConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.CourseLessonConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.CoursePageConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.CourseVedio
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.CustomOrderDetails
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.CustomOrderPage
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.EditProfileScreen
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ExpertDetailsPage
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.FavoriteScreenConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.LoginPage
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.MoreScreenTab
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.NotificationConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.PostDetailsConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.PostScreenConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.PrivacyPolicyPage
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.PurchaseHistoryConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.RechargeCheckout
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.RechargeSuccess
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.ReferAndEarnConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration.TermsAndConditions
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.DialogConfiguration
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.DialogConfiguration.CallDurationDialog
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.DialogConfiguration.ChatDurationDialog
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.DialogConfiguration.QueueDialogConfig
import tta.destinigo.talktoastro.core.navigation_decompose.configruation.DialogConfiguration.QueueStatusDialogConfig
import tta.destinigo.talktoastro.core.navigation_decompose.root_component.RootComponent
import tta.destinigo.talktoastro.feature_article.persentation.post_page.ArticleComponent
import tta.destinigo.talktoastro.feature_article.persentation.posts_page.ArticlesComponent
import tta.destinigo.talktoastro.feature_authentication.persentation.login_page.LoginPageComponent
import tta.destinigo.talktoastro.feature_authentication.persentation.otp_validation_page.OtpValidationComponent
import tta.destinigo.talktoastro.feature_authentication.persentation.register_page.RegisterComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info.CallConsultationComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_success_page.CallSuccessComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.QueueComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.model.ConsultationData
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet.QueueStatusComponent
import tta.destinigo.talktoastro.feature_call_consultation.persentation.voip_call_page.VoipCallComponent
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_bottom_sheet_info.ChatConsultationComponent
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_host.decompose.HostDefaultComponent
import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_queue_bottom_sheet_info.ChatQueueConsultationComponent
import tta.destinigo.talktoastro.feature_course.persentation.course_page.CourseComponent
import tta.destinigo.talktoastro.feature_course.persentation.course_preview_video.CourseVedioComponent
import tta.destinigo.talktoastro.feature_course.persentation.course_video.CourseLessonsComponent
import tta.destinigo.talktoastro.feature_course.persentation.courses_page.CoursesComponent
import tta.destinigo.talktoastro.feature_custom_order.CustomOrderComponent
import tta.destinigo.talktoastro.feature_custom_order.persentation.custom_order_details.CustomOrderDetailsComponent
import tta.destinigo.talktoastro.feature_expert_details.persentation.expert_detail_page.ExpertDetailsPageComponent
import tta.destinigo.talktoastro.feature_expert_details.persentation.expert_detail_page.ExpertDetailsPageEvent
import tta.destinigo.talktoastro.feature_expert_listing.presentation.ExpertListPageComponent
import tta.destinigo.talktoastro.feature_expert_listing.presentation.event.ExpertListPageEvent
import tta.destinigo.talktoastro.feature_expert_search.SearchScreenComponent
import tta.destinigo.talktoastro.feature_home.presentation.event.HomePageEvent
import tta.destinigo.talktoastro.feature_home.presentation.notificationsScreen.NotificationComponent
import tta.destinigo.talktoastro.feature_post.PostDetailsComponent
import tta.destinigo.talktoastro.feature_post.PostScreenComponent
import tta.destinigo.talktoastro.feature_profile.component.AboutUsComponent
import tta.destinigo.talktoastro.feature_profile.component.ChatConversationComponent
import tta.destinigo.talktoastro.feature_profile.component.ChatHistoryComponent
import tta.destinigo.talktoastro.feature_profile.component.ContactUsComponent
import tta.destinigo.talktoastro.feature_profile.component.EditProfileComponent
import tta.destinigo.talktoastro.feature_profile.component.FavoriteTabEvent
import tta.destinigo.talktoastro.feature_profile.component.MoreScreenEvent
import tta.destinigo.talktoastro.feature_profile.component.MoreScreenTabComponent
import tta.destinigo.talktoastro.feature_profile.component.PrivacyPolicyComponent
import tta.destinigo.talktoastro.feature_profile.component.PrivacyPolicyEvent
import tta.destinigo.talktoastro.feature_profile.component.TermsAndConditionsComponent
import tta.destinigo.talktoastro.feature_profile.component.TermsAndConditionsEvent
import tta.destinigo.talktoastro.feature_profile.favourites.persentation.FavoriteScreenComponent
import tta.destinigo.talktoastro.feature_profile.purchase_history.PurchaseHistoryComponent
import tta.destinigo.talktoastro.feature_profile.refer_and_earn.ReferAndEarnScreenComponent
import tta.destinigo.talktoastro.feature_profile.transaction_history.persentation.TransactionHistoryComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_checkout.RechargeCheckoutComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_failure.RechargeFailureComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_getway.PaymentGatewayComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_pack.ChoseRechargePackComponent
import tta.destinigo.talktoastro.feature_wallet.persentation.recharge_payment_success.RechargeSuccessComponent
import tta.destinigo.talktoastro.notification.NotificationManagerWrapper
import tta.destinigo.talktoastro.notification.NotificationPermissionManager
import tta.destinigo.talktoastro.shared.config.COURSES_LIST
import tta.destinigo.talktoastro.shared.config.CUSTOM_ORDER_LIST
import tta.destinigo.talktoastro.shared.data.CommonExpertInfo
import tta.destinigo.talktoastro.shared.local.ConfigProvider
import tta.destinigo.talktoastro.shared.local.UserInfoProvider
import tta.destinigo.talktoastro.shared.persentation.ExitConfirmationDialogComponent
import tta.destinigo.talktoastro.shared.persentation.dialog.NotificationPermissionComponent
import tta.destinigo.talktoastro.shared.persentation.image_viewer.ImageViewerComponent
import tta.destinigo.talktoastro.shared.persentation.login_dialog.LoginDialogComponent

object NavigationChild {
    val dialogNavigation = SlotNavigation<DialogConfiguration>()
    val navigation = StackNavigation<Configuration>()
    private val coroutine = CoroutineScope(SupervisorJob() + Dispatchers.Main)
    private val permissionManager: NotificationPermissionManager = NotificationManagerWrapper()

    private fun homePageEvent(event: HomePageEvent) {
        when (event) {
            is HomePageEvent.OnClickTopConsultant -> {
                navigation.pushNew(ExpertDetailsPage(event.expertCategory))
            }

            is HomePageEvent.OnClickCategory -> {
                when (event.category?.name) {
                    COURSES_LIST -> {
                        // Navigate to the LandingPage specific for Scientific Astrology
                        navigation.pushNew(Configuration.CoursesPageConfig)
                    }

                    CUSTOM_ORDER_LIST -> {
                        // Navigate to the CustomOrderPage
                        navigation.pushNew(CustomOrderPage)
                    }

                    else -> {
                        // Navigate to ExpertListPage for other categories
                        navigation.pushNew(
                            Configuration.ExpertListPage(
                                event.category?.name ?: "Expert List",
                                event.category?.id.toString(),
                                subCategory = event.category
                            )
                        )
                    }
                }
            }

            is HomePageEvent.OnCustomOrderItemClick -> {
                navigation.pushNew(
                    CustomOrderDetails(event.data)
                )
            }

            is HomePageEvent.OnLiveSessionClick -> Unit
            is HomePageEvent.OnSearchClick -> navigation.pushNew(Configuration.DisplaySearchExpertList)
            is HomePageEvent.OnClickLogin -> navigation.pushNew(LoginPage)
            is HomePageEvent.OnClickProfileIcon -> {
                navigation.pushNew(MoreScreenTab)
            }

            is HomePageEvent.OnClickPrivacyPolicy -> navigation.pushNew(PrivacyPolicyPage)
            is HomePageEvent.OnClickTermsAndConditions -> navigation.pushNew(
                TermsAndConditions
            )

            is HomePageEvent.OnClickWalletIcon -> navigation.pushNew(ChoseRechargePage)
            is HomePageEvent.OnChatConsultationStart -> onAuthenticationValidate {
                onQueueValidation(
                    commonExpertInfo = event.commonExpertInfo,
                    onValidated = {
                        dialogNavigation.activate(
                            ChatDurationDialog(
                                isEmergencyChat = event.isEmergency,
                                expertInfo = event.commonExpertInfo
                            )
                        )
                    }
                )
            }

            is HomePageEvent.OnCallConsultationStart -> onAuthenticationValidate {
                onQueueValidation(commonExpertInfo = event.commonExpertInfo, onValidated = {
                    dialogNavigation.activate(
                        CallDurationDialog(
                            isEmergencyCall = event.isEmergency, expertInfo = event.commonExpertInfo
                        )
                    )
                })
            }

            is HomePageEvent.OnRequiredRecharge -> {
                if (event.rechargeData == null) {
                    navigation.pushNew(ChoseRechargePage)
                    return
                }
                navigation.pushNew(
                    RechargeCheckout(
                        rechargeData = event.rechargeData
                    )
                )
            }

            is HomePageEvent.OnArticleClick -> {
                navigation.pushNew(ArticleListPageConfig)
            }

            is HomePageEvent.OnClickPostSeeAll -> navigation.pushNew(
                PostScreenConfig
            )

            is HomePageEvent.OnClickReadPost -> {
                navigation.pushNew(
                    PostDetailsConfig(event.id)
                )
            }

            HomePageEvent.onAoutUs -> {
                navigation.pushNew(
                    AboutUsConfig
                )
            }

            HomePageEvent.onContactUs -> {
                navigation.pushNew(
                    ContactUsConfig
                )
            }

            is HomePageEvent.OnQueueChatJoinDialog -> onAuthenticationValidate {
                dialogNavigation.activate(
                    configuration = DialogConfiguration.ChatQueueDialog(
                        expertInfo = event.commonExpertInfo,
                        timerTime = event.timeLeft,
                        category = event.category,
                    )
                )
            }

            is HomePageEvent.OnQueueConsultation -> {
                onAuthenticationValidate {
                    onQueueValidation(commonExpertInfo = event.commonExpertInfo, onValidated = {
                        dialogNavigation.activate(
                            QueueDialogConfig(
                                expertInfo = event.commonExpertInfo,
                                type = event.type.toString(),
                                isChatAvailable = event.isChatAvailable,
                                isCallAvailable = event.isCallAvailable,
                                waitingTime = event.waitingTime.toString(),
                                queNumber = event.queueNumber,
                                onQueueJoined = {
                                    event.onQueueChatConsJoined.invoke()
                                },
                            )
                        )
                    })
                }
            }

            is HomePageEvent.OnQueueStatus -> {
                onAuthenticationValidate {
                    dialogNavigation.activate(
                        QueueStatusDialogConfig(
                            expertInfo = event.commonExpertInfo,
                            onQueueJoined = {
                                event.onQueueChatConsJoined.invoke()
                            }
                        )
                    )
                }
            }

            is HomePageEvent.OnNotificationClick -> {
                navigation.pushNew(NotificationConfig)
            }
        }
    }

    private inline fun onAuthenticationValidate(onLoggedIn: () -> Unit) {
        val isUserLogin = UserInfoProvider.getIsLogin()
        return if (isUserLogin) onLoggedIn.invoke()
        else dialogNavigation.activate(DialogConfiguration.LoginPageDialogConfig)
    }

    private inline fun onQueueValidation(
        crossinline onValidated: () -> Unit,
        commonExpertInfo: CommonExpertInfo,
    ) {
        val isUserAlreadyInQueue = ConfigProvider.getQueueStatus()
        return if (isUserAlreadyInQueue) dialogNavigation.activate(
            QueueStatusDialogConfig(
                expertInfo = commonExpertInfo,
                onQueueJoined = { onValidated.invoke() },
                validationMessage = "You are already in queue,Exit to join another Queue/Consultation"
            )
        ) else onValidated.invoke()
    }

    fun createDialogChild(
        configuration: DialogConfiguration, context: ComponentContext
    ): RootComponent.DialogChild {
        return when (configuration) {
            is DialogConfiguration.LoginPageDialogConfig -> onLoginDialog(context)
            is QueueDialogConfig -> onQueueDialog(context, configuration)
            is QueueStatusDialogConfig -> onQueueStatusDialog(
                context, configuration
            )

            is DialogConfiguration.ExitDialogConfig -> onExitDialog(context) {
                configuration.onExitConfirmation.invoke()
            }

            is CallDurationDialog -> onCallDurationDialog(
                context, configuration
            )

            is DialogConfiguration.CallOptionDialog -> TODO()
            is ChatDurationDialog -> onChatDurationDialog(
                context, configuration
            )

            is DialogConfiguration.ChatQueueDialog -> onChatQueueDialog(context, configuration)
            is DialogConfiguration.PermissionDialog -> onPermissionDialog(context)
            is DialogConfiguration.ImageViewerPlatformDialog -> onFullScreenDialog(
                configuration,
                context
            )

            is DialogConfiguration.ImageViewerUrlDialog -> onFullScreenDialog(
                configuration,
                context
            )
        }
    }

    private fun onFullScreenDialog(
        configuration: DialogConfiguration.ImageViewerUrlDialog,
        context: ComponentContext
    ): RootComponent.DialogChild =
        RootComponent.DialogChild.ImageViewerDialogChild(
            ImageViewerComponent(
                context = context,
                onDismiss = {
                    dialogNavigation.dismiss()
                },
                selectedUrl = configuration.imageUrl
            )
        )

    private fun onFullScreenDialog(
        configuration: DialogConfiguration.ImageViewerPlatformDialog,
        context: ComponentContext
    ): RootComponent.DialogChild =
        RootComponent.DialogChild.ImageViewerDialogChild(
            ImageViewerComponent(
                context = context,
                onDismiss = {
                    dialogNavigation.dismiss()
                },
                selectedFile = configuration.imageFile
            )
        )

    private fun onPermissionDialog(context: ComponentContext): RootComponent.DialogChild =
        RootComponent.DialogChild.PermissionDialogChild(
            component = NotificationPermissionComponent(
                component = context,
                onDismiss = {
                    dialogNavigation.dismiss()
                },
                onGrantClicked = {
                    coroutine.launch {
                        if (permissionManager.isPermissionGranted()) permissionManager.requestPermission()
                    }
                    dialogNavigation.dismiss()
                })
        )


    private fun onChatQueueDialog(
        context: ComponentContext, configuration: DialogConfiguration.ChatQueueDialog
    ) = RootComponent.DialogChild.ChatQueueJoinDialog(
        ChatQueueConsultationComponent(
            context = context,
            category = "",
            expertInfo = configuration.expertInfo,
            durationToJoin = configuration.timerTime,
            onClose = {
                dialogNavigation.dismiss()
            },
            onConnectChat = { agoraData, maxDuration: String ->
                dialogNavigation.dismiss()
                navigation.pushNew(
                    Configuration.ChatConcernPage(
                        expertId = configuration.expertInfo.expertId.toString(),
                        expertName = configuration.expertInfo.expertName,
                        expertImage = configuration.expertInfo.expertProfileImageUrl.toString(),
                        expertSkills = configuration.expertInfo.expertSkills.toString(),
                        chatDuration = maxDuration,
                        category = configuration.category,
                        chatType = "Normal",
                        agoraData = agoraData
                    )
                )
            },
        )
    )


    private fun onChatDurationDialog(
        context: ComponentContext, configuration: ChatDurationDialog
    ) = RootComponent.DialogChild.ChatDurationDialogChild(
        ChatConsultationComponent(
            context = context,
            _isEmergency = configuration.isEmergencyChat,
            expertInfo = configuration.expertInfo,
            onClose = { dialogNavigation.dismiss() },
            onConnect = { duration: String, category: String, chatType: String ->
                navigation.pushNew(
                    Configuration.ChatConcernPage(
                        expertId = configuration.expertInfo.expertId.toString(),
                        expertName = configuration.expertInfo.expertName,
                        expertImage = configuration.expertInfo.expertProfileImageUrl.toString(),
                        expertSkills = configuration.expertInfo.expertSkills.toString(),
                        chatDuration = duration,
                        category = category,
                        chatType = chatType
                    )
                )
                dialogNavigation.dismiss()
            },
            onRechargeAgain = { rechargeData ->
                if (rechargeData == null) {
                    navigation.pushNew(ChoseRechargePage)
                } else {
                    navigation.pushNew(
                        RechargeCheckout(
                            rechargeData = rechargeData
                        )
                    )
                }
                dialogNavigation.dismiss()
            })
    )

    private fun onCallDurationDialog(
        context: ComponentContext, configuration: CallDurationDialog
    ) = RootComponent.DialogChild.CallDurationDialogChild(
        CallConsultationComponent(
            context = context,
            _isEmergency = configuration.isEmergencyCall,
            expertInfo = configuration.expertInfo,
            onClose = {
                dialogNavigation.dismiss()
            },
            onNavigateRechargeCheckOut = { rechargeData ->
                if (rechargeData == null) {
                    navigation.pushNew(ChoseRechargePage)
                } else {
                    navigation.pushNew(
                        RechargeCheckout(
                            rechargeData = rechargeData
                        )
                    )
                }
                dialogNavigation.dismiss()
            },
            onLetsConnectButtonClick = {
                navigation.pushNew(
                    Configuration.CallWaitingSuccessComponent(
                        expertId = configuration.expertInfo.expertId.toString(),
                        expertName = configuration.expertInfo.expertName,
                        expertImage = configuration.expertInfo.expertProfileImageUrl.toString(),
                        expertSkills = configuration.expertInfo.expertSkills.toString(),
                        callType = if (configuration.isEmergencyCall) "Emergency" else "Normal"
                    )
                )
                dialogNavigation.dismiss()
            },
            onVoIpCallStart = { duration ->
                navigation.pushNew(
                    Configuration.VoIPCallConfig(configuration.expertInfo, duration)
                )
                dialogNavigation.dismiss()
            })
    )


    private fun onExitDialog(context: ComponentContext, onExit: () -> Unit) =
        RootComponent.DialogChild.ExitDialog(
            ExitConfirmationDialogComponent(
                context = context,
                onDismiss = {
                    dialogNavigation.dismiss()
                },
                onConfirmExit = {
                    onExit.invoke()
                })
        )

    private fun onLoginDialog(context: ComponentContext) = RootComponent.DialogChild.LoginChild(
        LoginDialogComponent(
            context = context,
            onLoginClicked = {
                navigation.pushNew(LoginPage)
                dialogNavigation.dismiss()
            },
            onDismiss = {
                dialogNavigation.dismiss()
            })
    )

    private fun onQueueDialog(
        context: ComponentContext, configuration: QueueDialogConfig
    ) = RootComponent.DialogChild.QueueDialogChild(
        QueueComponent(
            componentContext = context,
            commonExpertInfo = configuration.expertInfo,
            consultationType = configuration.type,
            onDismiss = { isJoined ->
                if (isJoined) {
                    configuration.onQueueJoined.invoke()
                }
                dialogNavigation.dismiss()
            },
            chatConsultationData = ConsultationData(
                isAvailable = configuration.isChatAvailable,
                isOnline = configuration.isChatAvailable,
                waitTime = if (configuration.waitingTime.trim()
                        .isEmpty()
                ) "Unknown" else configuration.waitingTime,
                queueNo = if (configuration.queNumber <= 1) "Next In Queue" else configuration.queNumber.toString()
            ),
            callConsultationData = ConsultationData(
                isAvailable = configuration.isCallAvailable,
                isOnline = configuration.isCallAvailable,
                waitTime = if (configuration.waitingTime.trim()
                        .isEmpty()
                ) "Unknown" else configuration.waitingTime,
                queueNo = if (configuration.queNumber <= 1) "Next In Queue" else configuration.queNumber.toString()
            )
        )
    )

    private fun onQueueStatusDialog(
        context: ComponentContext, configuration: QueueStatusDialogConfig
    ) = RootComponent.DialogChild.QueueStatusDialogChild(
        QueueStatusComponent(
            expertInfo = configuration.expertInfo, componentContext = context,
            onDismiss = { isJoined ->
                if (isJoined) {
                    configuration.onQueueJoined.invoke()
                }
                dialogNavigation.dismiss()
            },
            errorQueueMsg = configuration.validationMessage
        )
    )

    fun createChild(
        configuration: Configuration, context: ComponentContext
    ): RootComponent.Child {
        return when (configuration) {

            is MoreScreenTab -> onMoreScreenTab(context)
            is LoginPage -> onLoginPage(context)
            is Configuration.OtpValidationPage -> onOtpValidationPage(configuration, context)
            is Configuration.RegistrationPage -> registrationPage(context)
            is Configuration.ExpertListPage -> onExpertListPage(context, configuration)
            is ExpertDetailsPage -> onExpertDetailsPage(context, configuration)
            is ChoseRechargePage -> onChoseRechargePage(context)
            is Configuration.CoursesPageConfig -> onCoursesPage(context)
            is CoursePageConfig -> onCoursePage(context, configuration.slug)
            is PrivacyPolicyPage -> onPrivacyPolicyPage(context)
            is TermsAndConditions -> onTermsAndConditions(context)
            is EditProfileScreen -> onEditProfileScreen(context)
            is RechargeCheckout -> rechargeCheckout(context, configuration)
            is Configuration.PaymentGateway -> onPaymentGateway(context, configuration)
            is Configuration.RechargeFailure -> onRechargeFailure(context, configuration)
            is RechargeSuccess -> onRechargeSuccess(context, configuration)
            is Configuration.DisplaySearchExpertList -> displaySearchExpertList(context)
            is Configuration.ChatConcernPage -> onChatHostChild(configuration, context)
            is Configuration.CallPlaceSuccessful -> onCallPlaceSuccess(context, configuration)
            is Configuration.CallWaitingSuccessComponent -> onCallWaitingSuccess(
                context, configuration
            )

            is Configuration.TransactionHistoryComponent -> transactionHistory(context)
            is Configuration.VoIPCallConfig -> onVoIPCall(context, configuration)
            is ChatHistory -> onChatHistory(context)
            is Configuration.ChatConversationScreen -> onChatConversationScreen(
                context, configuration
            )

            is ArticleDetailPageConfig -> onArticleDetailPage(context, configuration)
            is CustomOrderPage -> onCustomOrderPage(context)
            is CustomOrderDetails -> onCustomOrderDetailsPage(context, configuration)
            is PurchaseHistoryConfig -> onPurchaseHistoryPage(context)
            is ReferAndEarnConfig -> onReferEarnPage(context)
            is PostScreenConfig -> onPostList(context)
            is PostDetailsConfig -> onPostPage(context, configuration)
            is FavoriteScreenConfig -> onFavoritePage(context)
            is AboutUsConfig -> onAboutPage(context)
            is ContactUsConfig -> onContactUs(context)
            is BottomNavigationConfiguration -> onBottomNavigation(context)
            is ArticleListPageConfig -> onArticleListPage(context)
            is CourseLessonConfig -> onCourseLessonConfig(context, configuration)
            is CourseVedio -> onCourseVideo(context, configuration)
            is NotificationConfig -> onNotification(context)
        }
    }

    private fun onNotification(context: ComponentContext) = RootComponent.Child.NotificationClid(
        NotificationComponent(
            context = context,
            onBackPress = { navigation.pop() }
        )
    )

    private fun onCourseLessonConfig(
        context: ComponentContext, configuration: CourseLessonConfig
    ) = RootComponent.Child.CourseLessonChild(
        CourseLessonsComponent(
            context = context,
            slug = configuration.id,
            onClose = {
                navigation.pop()
            },
        )
    )

    private fun onCourseVideo(context: ComponentContext, configuration: CourseVedio) =
        RootComponent.Child.CourseVedio(
            CourseVedioComponent(
                context = context,
                slug = configuration.data,
                onClose = {
                    navigation.pop()
                },
                navigateNext = {
                    navigation.pushNew(CourseLessonConfig(it))
                },
                navigateBack = { slug ->
                    if (slug.isNotEmpty()) {
                        //dialogNavigation.activate(Con)
                        navigation.pushNew(CoursePageConfig(slug))
                    } else {
                        navigation.pushNew(Configuration.CoursesPageConfig)
                    }

                },
                notLoginUser = { s: String, s1: String ->

                },
                alreadyPurchased = { id ->
                    if (id != null) {
                        navigation.pushNew(CourseLessonConfig(id = id))
                    } else {
                        navigation.pushNew(Configuration.CoursesPageConfig)
                    }
                },
                navigateActualCourse = {
                    navigation.pushNew(CoursePageConfig("learn-vedic-astrology"))
                }

            ))

    private fun onArticleListPage(context: ComponentContext) = RootComponent.Child.ArticleHostChild(
        ArticlesComponent(
            componentContext = context,
            onClosePage = {
                navigation.pop()
            },
            openPost = {
                navigation.pushNew(ArticleDetailPageConfig(it))
            },
        )
    )

    private fun onMoreScreenTab(context: ComponentContext) =
        RootComponent.Child.MoreScreenTab(
            MoreScreenTabComponent(
                context = context, onMoreScreenEvent = { moreScreenEvent ->
                    when (moreScreenEvent) {
                        MoreScreenEvent.onClickWalletBlance -> navigation.pushNew(ChoseRechargePage)
                        MoreScreenEvent.onPricayPolicyClick -> navigation.pushNew(PrivacyPolicyPage)
                        MoreScreenEvent.onTermAndConditionClick -> navigation.pushNew(
                            TermsAndConditions
                        )

                        MoreScreenEvent.OnClickEditProfile -> onAuthenticationValidate {
                            navigation.pushNew(EditProfileScreen)
                        }

                        MoreScreenEvent.onBackButtonClick -> navigation.pop()
                        MoreScreenEvent.onReferAndEarnClick -> navigation.pushNew(ReferAndEarnConfig)
                        MoreScreenEvent.onTransactionHistoryScreenClick -> navigation.pushNew(
                            Configuration.TransactionHistoryComponent
                        )

                        MoreScreenEvent.onSignOutButtonClick -> {
                            navigation.popToFirst()
                        }

                        MoreScreenEvent.onWalletButtonClick -> navigation.pushNew(ChoseRechargePage)
                        MoreScreenEvent.onChatHistoryClick -> navigation.pushNew(ChatHistory)
                        MoreScreenEvent.onPurchaseHistoryClick -> navigation.pushNew(
                            PurchaseHistoryConfig
                        )

                        MoreScreenEvent.OnFavoriteExpertClick -> navigation.pushNew(
                            FavoriteScreenConfig
                        )

                        MoreScreenEvent.OnLoginClick -> navigation.pushNew(
                            LoginPage
                        )
                    }
                })
        )

    private fun onLoginPage(context: ComponentContext) =
        RootComponent.Child.LoginPage(
            LoginPageComponent(
                context = context,
                navigateToOtpValidationPage = { firstString, secondString, isWhatsappUpdatesChecked ->
                    navigation.replaceCurrent(
                        Configuration.OtpValidationPage(
                            firstString, secondString, isWhatsappUpdatesChecked
                        )
                    )
                },
                onPrivacyPolicyClick = {
                    navigation.pushNew(TermsAndConditions)
                },
                onBackPage = { navigation.pop() })
        )

    private fun onOtpValidationPage(
        configuration: Configuration.OtpValidationPage, context: ComponentContext
    ) = RootComponent.Child.OtpValidationPage(
        OtpValidationComponent(
            mobileNumber = configuration.mobileNumber,
            mobileCode = configuration.mobileCode,
            isWhatsappUpdatesChecked = false,
            componentContext = context,
            onRegisterEvent = {
                navigation.replaceCurrent(Configuration.RegistrationPage)
            },
            onDashboardEvent = {
                navigation.popToFirst()
            },
            onBackPage = { navigation.pop() })
    )

    private fun registrationPage(context: ComponentContext) =
        RootComponent.Child.RegistrationPage(RegisterComponent(context = context, onRegistration = {
            navigation.pop()
        }, onBackPage = { navigation.pop() }))

    @OptIn(DelicateDecomposeApi::class)
    private fun onExpertListPage(
        context: ComponentContext, configuration: Configuration.ExpertListPage
    ) = RootComponent.Child.ExpertListPage(
        ExpertListPageComponent(
            context = context,
            categoryId = configuration.categoryId,
            categoryName = configuration.categoryName,
            subCategoriesGiven = configuration.subCategory,
            onExpertListPageEvent = { event: ExpertListPageEvent ->
                when (event) {
                    is ExpertListPageEvent.OnBackPressed -> navigation.pop()
                    is ExpertListPageEvent.OnCallClick -> onAuthenticationValidate {

                        onQueueValidation(commonExpertInfo = event.info, onValidated = {
                            dialogNavigation.activate(
                                CallDurationDialog(
                                    isEmergencyCall = event.isEmergency,
                                    expertInfo = event.info,
                                )
                            )
                        })
                    }

                    is ExpertListPageEvent.OnChatClick -> onAuthenticationValidate {

                        onQueueValidation(commonExpertInfo = event.info, onValidated = {
                            dialogNavigation.activate(
                                ChatDurationDialog(
                                    isEmergencyChat = event.isEmergency, expertInfo = event.info
                                )
                            )
                        })
                    }

                    is ExpertListPageEvent.OnExpertDetailsPage -> navigation.pushNew(
                        ExpertDetailsPage(
                            event.expertId
                        )
                    )

                    is ExpertListPageEvent.OnLoginClick -> onAuthenticationValidate {
                        dialogNavigation.activate(DialogConfiguration.LoginPageDialogConfig)
                    }

                    is ExpertListPageEvent.OnQueueConsultation -> onAuthenticationValidate {

                        onQueueValidation(commonExpertInfo = event.commonExpertInfo, onValidated = {
                            dialogNavigation.activate(
                                QueueDialogConfig(
                                    expertInfo = event.commonExpertInfo,
                                    type = event.type.name,
                                    isChatAvailable = event.isChatAvailable,
                                    isCallAvailable = event.isCallAvailable,
                                    waitingTime = event.waitingTime.toString(),
                                    queNumber = event.queueNumber,
                                    onQueueJoined = event.onQueueChatConsJoined
                                )
                            )
                        })
                    }

                    is ExpertListPageEvent.OnQueueStatus -> dialogNavigation.activate(
                        QueueStatusDialogConfig(
                            expertInfo = event.commonExpertInfo,
                            onQueueJoined = event.onQueueChatConsJoined
                        )
                    )

                    is ExpertListPageEvent.OnSearchFieldClick -> navigation.push(Configuration.DisplaySearchExpertList)

                }
            })
    )

    private fun onExpertDetailsPage(
        context: ComponentContext, configuration: ExpertDetailsPage
    ) = RootComponent.Child.ExpertDetailsPage(
        ExpertDetailsPageComponent(
            context = context,
            expertId = configuration.expertId,
            onPageEvent = { event ->
                when (event) {
                    ExpertDetailsPageEvent.OnBackButtonClick -> navigation.pop()
                    is ExpertDetailsPageEvent.OnCallButtonClick ->
                        onAuthenticationValidate {
                            onQueueValidation(
                                commonExpertInfo = event.commonExpertInfo,
                                onValidated = {
                                    dialogNavigation.activate(
                                        CallDurationDialog(
                                            isEmergencyCall = event.isEmergency,
                                            expertInfo = event.commonExpertInfo
                                        )
                                    )
                                })
                        }


                    is ExpertDetailsPageEvent.OnChatButtonClick -> {
                        onAuthenticationValidate {
                            onQueueValidation(
                                commonExpertInfo = event.commonExpertInfo,
                                onValidated = {
                                    dialogNavigation.activate(
                                        ChatDurationDialog(
                                            isEmergencyChat = event.isEmergency,
                                            expertInfo = event.commonExpertInfo
                                        )
                                    )
                                })
                        }
                    }

                    is ExpertDetailsPageEvent.OnQueueConsultation -> onAuthenticationValidate {
                        onQueueValidation(commonExpertInfo = event.commonExpertInfo, onValidated = {
                            dialogNavigation.activate(
                                QueueDialogConfig(
                                    expertInfo = event.commonExpertInfo,
                                    type = event.type.name,
                                    isChatAvailable = event.isChatAvailable,
                                    isCallAvailable = event.isCallAvailable,
                                    waitingTime = event.waitingTime.toString(),
                                    queNumber = event.queueNumber,
                                    onQueueJoined = event.onQueueChatConsJoined
                                )
                            )
                        })
                    }


                    is ExpertDetailsPageEvent.OnQueueStatus -> dialogNavigation.activate(
                        QueueStatusDialogConfig(
                            expertInfo = event.commonExpertInfo,
                            onQueueJoined = event.onQueueChatConsJoined
                        )
                    )

                    is ExpertDetailsPageEvent.OnRelatedExpertCardClick -> navigation.pushNew(
                        ExpertDetailsPage(
                            event.expertId
                        )
                    )

                    ExpertDetailsPageEvent.OnClickLoginButton -> dialogNavigation.activate(
                        DialogConfiguration.LoginPageDialogConfig
                    )
                }
            },
        )
    )

    private fun onChoseRechargePage(context: ComponentContext) =
        RootComponent.Child.ChoseRechargePage(
            ChoseRechargePackComponent(
                context = context,
                onBackPressed = { navigation.pop() },
                navigateToRechargeCheckout = {
                    navigation.pushNew(RechargeCheckout(it))
                })
        )

    private fun onPrivacyPolicyPage(context: ComponentContext) =
        RootComponent.Child.PrivacyPolicyPage(
            PrivacyPolicyComponent(context = context) { privacyPolicyEvent ->
                when (privacyPolicyEvent) {
                    PrivacyPolicyEvent.OnBackKeyPress -> navigation.pop()
                }

            })

    private fun onTermsAndConditions(context: ComponentContext) =
        RootComponent.Child.TermsAndConditions(
            TermsAndConditionsComponent(context = context) { termsAndConditionsEvent ->
                when (termsAndConditionsEvent) {
                    TermsAndConditionsEvent.OnBackKeyPress -> navigation.pop()
                }
            })

    private fun onEditProfileScreen(context: ComponentContext) =
        RootComponent.Child.EditProfileScreen(
            EditProfileComponent(context = context, onBackPress = {
                navigation.pop()
            })
        )

    private fun rechargeCheckout(
        context: ComponentContext,
        configuration: RechargeCheckout
    ) = RootComponent.Child.RechargeCheckout(
        RechargeCheckoutComponent(
            context = context,
            onProceedToPayment = { paymentGatewayArg ->
                navigation.replaceCurrent(
                    Configuration.PaymentGateway(
                        paymentGatewayArg,
                        isCustomOrder = configuration.isCustomOrder
                    )
                )
            },
            onBackPressed = { navigation.pop() },
            onShowAllCouponClick = {
//                navigation.pushNew(Configuration.AllCouponCode)
            },
            _isCustomOrder = configuration.isCustomOrder,
            _image = configuration.image,
            customOrderConfirm = {

            },
            customOrderError = {

            },
            rechargeData = configuration.rechargeData,
            heading = configuration.orderHeading
        )
    )

    private fun onPaymentGateway(
        context: ComponentContext,
        configuration: Configuration.PaymentGateway
    ) = RootComponent.Child.PaymentGateway(
        PaymentGatewayComponent(
            context = context,
            paymentGatewayArg = configuration.paymentGatewayArg,
            onRechargeSuccess = { topUpAmount, customOrderId ->
                if (topUpAmount.equals(
                        "CustomOrder",
                        true
                    ) && customOrderId.isNotEmpty()
                ) {
                    navigation.replaceCurrent(
                        RechargeSuccess(
                            topUpAmount,
                            isCustomOrderPayment = true
                        )
                    )
                } else {
                    navigation.replaceCurrent(
                        RechargeSuccess(
                            topUpAmount,
                            isCustomOrderPayment = false
                        )
                    )
                }
            },
            _isCustomOrder = configuration.isCustomOrder,
            onRechargeFailed = { topUpAmount, isCustomOrder ->
                //if (topUpAmount.equals("CustomOrder", true).not()) {
                if (isCustomOrder) {
                    navigation.replaceCurrent(
                        Configuration.RechargeFailure(
                            topUpAmount = topUpAmount,
                            isCustomOrderPayment = true
                        )
                    )
                } else {
                    navigation.replaceCurrent(
                        Configuration.RechargeFailure(
                            topUpAmount = topUpAmount,
                            isCustomOrderPayment = false
                        )
                    )
                }
            })
    )

    private fun onRechargeFailure(
        context: ComponentContext,
        configuration: Configuration.RechargeFailure
    ) = RootComponent.Child.RechargeFailure(
        RechargeFailureComponent(
            context = context,
            _topUpAmount = configuration.topUpAmount,
            rechargeAgain = {
                navigation.pop()
            },
            getSupport = {
                navigation.popToFirst()
            },
            _isCustomOrderPayment = configuration.isCustomOrderPayment
        )
    )

    private fun onRechargeSuccess(
        context: ComponentContext,
        configuration: RechargeSuccess
    ) = RootComponent.Child.RechargeSuccess(
        RechargeSuccessComponent(
            context = context,
            _topUpAmount = configuration.topUpAmount,
            onDone = {
                navigation.pop()
            },
            rechargeMore = {
                navigation.pop()
            },
            _isCustomOrderPayment = configuration.isCustomOrderPayment
        )
    )

    private fun displaySearchExpertList(context: ComponentContext) =
        RootComponent.Child.DisplaySearchExpertList(
            component = SearchScreenComponent(
                context = context,
                onBackPress = { navigation.pop() },
                onClickExpertCard = { expertId ->
                    navigation.pushNew(
                        ExpertDetailsPage(
                            expertId
                        )
                    )
                })
        )

    private fun onChatHostChild(
        configuration: Configuration.ChatConcernPage,
        context: ComponentContext
    ) = RootComponent.Child.ChatHostChild(
        HostDefaultComponent(
            commonExpertInfo = CommonExpertInfo(
                expertId = configuration.expertId,
                expertName = configuration.expertName,
                expertProfileImageUrl = configuration.expertImage,
                expertSkills = configuration.expertSkills
            ),
            chatDuration = configuration.chatDuration,
            componentContext = context,
            onClose = { navigation.pop() },
            category = configuration.category,
            chatType = configuration.chatType,
            agoraData = configuration.agoraData,
            closeWithRecharge = {
                navigation.pop()
                navigation.pushNew(ChoseRechargePage)
            },
            onFullScreenImage = {
                dialogNavigation.activate(DialogConfiguration.ImageViewerPlatformDialog(it))
            },
            onFullScreenImageUrl = {
                dialogNavigation.activate(DialogConfiguration.ImageViewerUrlDialog(it))
            }
        )
    )

    private fun onCallPlaceSuccess(
        context: ComponentContext,
        configuration: Configuration.CallPlaceSuccessful
    ) = RootComponent.Child.CallPlaceSuccess(
        component = CallSuccessComponent(
            context = context,
            _expertId = configuration.expertId,
            _expertName = configuration.expertName,
            _expertSkills = configuration.expertSkills,
            _expertImage = configuration.expertImage,
            onClosePage = {
                navigation.popTo(0)
            },
            onTimeOutOver = {
                navigation.popWhile { it == BottomNavigationConfiguration }
            },
            _callType = configuration.callType
        )
    )

    private fun onCallWaitingSuccess(
        context: ComponentContext,
        configuration: Configuration.CallWaitingSuccessComponent
    ) = RootComponent.Child.CallWaitingSuccess(
        CallSuccessComponent(
            context = context,
            _expertId = configuration.expertId,
            _expertName = configuration.expertName,
            _expertImage = configuration.expertImage,
            _expertSkills = configuration.expertSkills,
            onClosePage = { navigation.popTo(0) },
            onTimeOutOver = { navigation.popToFirst() },
            _callType = configuration.callType
        )
    )

    private fun transactionHistory(context: ComponentContext) =
        RootComponent.Child.TransactionHistory(
            TransactionHistoryComponent(
                context = context,
                onBackButtonClick = { navigation.pop() })
        )

    private fun onVoIPCall(
        context: ComponentContext,
        configuration: Configuration.VoIPCallConfig
    ) = RootComponent.Child.VoIPCall(
        VoipCallComponent(
            context = context,

            expertInfo = configuration.expertInfo,
            _callDuration = configuration.callDuration,
            onClose = {
                navigation.pop()
            },
        )
    )

    private fun onChatHistory(context: ComponentContext) =
        RootComponent.Child.ChatHistory(
            ChatHistoryComponent(
                context = context,
                onBackPress = { navigation.pop() },
                onChatCardClick = { chatId, name, image, duration ->
                    navigation.pushNew(
                        Configuration.ChatConversationScreen(
                            chatId, name, image, duration
                        )
                    )
                },
                onLowBalance = {
                    navigation.pushNew(ChoseRechargePage)
                },
                onChatConsultation = { expertId, name, image, skill, duration, category, chatType ->
                    //navigation.pushNew(Configuration.)

                    navigation.pushNew(
                        Configuration.ChatConcernPage(
                            expertId = expertId,
                            expertName = name,
                            expertImage = image,
                            expertSkills = skill,
                            chatDuration = duration,
                            category = category,
                            chatType = chatType
                        )
                    )
                },
                onRechargeRequired = { data ->
                    if (data == null) {
                        navigation.pushNew(ChoseRechargePage)
                        return@ChatHistoryComponent
                    }
                },
                onLoginClick = {}),
            ExpertDetailsPageComponent(
                context = context,
                expertId = 0,
                onPageEvent = {}
            )
        )

    private fun onChatConversationScreen(
        context: ComponentContext,
        configuration: Configuration.ChatConversationScreen
    ) = RootComponent.Child.ChatConversationScreen(
        ChatConversationComponent(
            context = context,
            onBackPress = { navigation.pop() },
            _chatId = configuration.chatId,
            _expertName = configuration.name,
            _expertImage = configuration.image,
            _chatDuration = configuration.duration
        )
    )

    private fun onArticleDetailPage(
        context: ComponentContext,
        configuration: ArticleDetailPageConfig
    ) = RootComponent.Child.ArticleDetailPage(
        ArticleComponent(
            componentContext = context,
            slug = configuration.slug,
            onClose = { navigation.pop() })
    )

    private fun onCustomOrderPage(context: ComponentContext) =
        RootComponent.Child.CustomOrderPage(
            CustomOrderComponent(
                context = context,
                onBackPress = { navigation.pop() },
                onCradClick = { data ->
                    navigation.pushNew(
                        CustomOrderDetails(
                            data = data
                        )
                    )
                })
        )

    private fun onCustomOrderDetailsPage(
        context: ComponentContext,
        configuration: CustomOrderDetails
    ): RootComponent.Child {
        return RootComponent.Child.CustomOrderDetails(
            CustomOrderDetailsComponent(
                context = context,
                onBackPress = { navigation.pop() },
                _data = configuration.data,
                onEnrollNowClick = { data, image, heading ->
                    navigation.pushNew(
                        RechargeCheckout(
                            rechargeData = data,
                            isCustomOrder = true,
                            image = image,
                            orderHeading = heading
                        )
                    )

                },
                onLoginClick = {
                    navigation.pushNew(
                        LoginPage
                    )
                })
        )
    }

    private fun onPurchaseHistoryPage(context: ComponentContext) =
        RootComponent.Child.PurchaseHistory(
            PurchaseHistoryComponent(
                context = context,
                onBack = { navigation.pop() },
                onPurchaseHistoryCardClick = { data ->
//                navigation.pushNew(Configuration.CustomOrderLesson(data))
                })
        )

    private fun onReferEarnPage(context: ComponentContext) =
        RootComponent.Child.ReferAndEarn(
            ReferAndEarnScreenComponent(
                context = context,
                onBackButtonClick = { navigation.pop() })
        )

    private fun onPostList(context: ComponentContext) =
        RootComponent.Child.PostScreen(
            PostScreenComponent(
                context = context,
                onBackClick = { navigation.pop() },
                onPostClick = { postData ->
                    navigation.pushNew(
                        PostDetailsConfig(
                            id = postData
                        )
                    )
                })
        )

    private fun onPostPage(
        context: ComponentContext,
        configuration: PostDetailsConfig
    ) =
        RootComponent.Child.PostDetailsScreenChild(
            PostDetailsComponent(
                context = context,
                onBackClick = { navigation.pop() },
                _postData = configuration.id
            )
        )

    private fun onFavoritePage(
        context: ComponentContext,
    ) =
        RootComponent.Child.FavoriteScreenChild(
            FavoriteScreenComponent(
                context,
                onFavoriteTabEvent = { event ->
                    when (event) {
                        FavoriteTabEvent.OnBackClick -> {
                            navigation.pop()
                        }

                        is FavoriteTabEvent.OnCallConsultation -> onAuthenticationValidate {
                            onQueueValidation(
                                commonExpertInfo = event.commonExpertInfo,
                                onValidated = {
                                    dialogNavigation.activate(
                                        CallDurationDialog(
                                            isEmergencyCall = event.isEmergency,
                                            expertInfo = event.commonExpertInfo
                                        )
                                    )
                                })
                        }

                        is FavoriteTabEvent.OnCardClick -> {
                            event.data.expertId?.let {
                                ExpertDetailsPage(
                                    it
                                )
                            }
                                ?.let {
                                    navigation.pushNew(
                                        it
                                    )
                                }
                        }

                        is FavoriteTabEvent.OnChatConsultation -> onAuthenticationValidate {
                            onQueueValidation(
                                commonExpertInfo = event.commonExpertInfo,
                                onValidated = {
                                    dialogNavigation.activate(
                                        ChatDurationDialog(
                                            isEmergencyChat = event.isEmergency,
                                            expertInfo = event.commonExpertInfo
                                        )
                                    )
                                })
                        }

                        is FavoriteTabEvent.OnQueueConsultation -> onAuthenticationValidate {

                            onQueueValidation(
                                commonExpertInfo = event.commonExpertInfo,
                                onValidated = {
                                    dialogNavigation.activate(
                                        QueueDialogConfig(
                                            expertInfo = event.commonExpertInfo,
                                            type = event.type.name,
                                            isChatAvailable = event.isChatAvailable,
                                            isCallAvailable = event.isCallAvailable,
                                            waitingTime = event.waitingTime.toString(),
                                            queNumber = event.queueNumber,
                                            onQueueJoined = event.onQueueChatConsJoined
                                        )
                                    )
                                })
                        }

                        is FavoriteTabEvent.OnQueueStatus -> dialogNavigation.activate(
                            QueueStatusDialogConfig(
                                expertInfo = event.commonExpertInfo,
                                onQueueJoined = event.onQueueChatConsJoined
                            )
                        )

                        is FavoriteTabEvent.OnLoginClick -> {
                            navigation.pushNew(Configuration.LoginPage)
                        }
                    }
                })
        )

    private fun onAboutPage(
        context: ComponentContext
    ) =
        RootComponent.Child.AboutUs(
            AboutUsComponent(
                context = context,
                onBackPress = {
                    navigation.pop()
                })
        )

    private fun onContactUs(
        context: ComponentContext
    ) =
        RootComponent.Child.ContactUs(
            ContactUsComponent(
                context = context,
                onBackPress = {
                    navigation.pop()
                })
        )

    private fun onCoursesPage(
        componentContext: ComponentContext
    ) =
        RootComponent.Child.CoursesPageChild(
            CoursesComponent(
                context = componentContext,
                onBackButtonClick = { navigation.pop() },
                onRegisterButtonClick = { slug ->
                    navigation.pushNew(
                        CoursePageConfig(
                            slug
                        )
                    )
                })
        )

    private fun onCoursePage(
        componentContext: ComponentContext,
        slug: String
    ) =
        RootComponent.Child.CoursePageChild(
            CourseComponent(
                context = componentContext,
                slug = slug,
                onClose = { navigation.pop() },
                alreadyParches = {
                    navigation.pushNew(
                        CourseLessonConfig(
                            it
                        )
                    )
                },
                onFree = { data ->
                    navigation.pushNew(
                        CourseVedio(
                            data
                        )
                    )
                },

                )
        )

    private fun onBottomNavigation(
        context: ComponentContext
    ): RootComponent.Child {
        return RootComponent.Child.BottomNavigationChild(
            BottomNavigationComponent(
                context = context,
                homePageEvent = { event ->
                    homePageEvent(
                        event
                    )
                },
                moreScreenEvent = { event ->
                    when (event) {
                        MoreScreenEvent.onClickWalletBlance -> navigation.pushNew(
                            ChoseRechargePage
                        )

                        MoreScreenEvent.onPricayPolicyClick -> navigation.pushNew(
                            PrivacyPolicyPage
                        )

                        MoreScreenEvent.onTermAndConditionClick -> navigation.pushNew(
                            TermsAndConditions
                        )

                        MoreScreenEvent.OnClickEditProfile -> onAuthenticationValidate {
                            navigation.pushNew(
                                EditProfileScreen
                            )
                        }

                        MoreScreenEvent.onBackButtonClick -> navigation.pop()
                        MoreScreenEvent.onReferAndEarnClick -> navigation.pushNew(
                            ReferAndEarnConfig
                        )

                        MoreScreenEvent.onTransactionHistoryScreenClick -> navigation.pushNew(
                            Configuration.TransactionHistoryComponent
                        )

                        MoreScreenEvent.onSignOutButtonClick -> {
                            navigation.popToFirst()
                        }

                        MoreScreenEvent.onWalletButtonClick -> navigation.pushNew(
                            ChoseRechargePage
                        )

                        MoreScreenEvent.onChatHistoryClick -> navigation.pushNew(
                            ChatHistory
                        )

                        MoreScreenEvent.onPurchaseHistoryClick -> navigation.pushNew(
                            PurchaseHistoryConfig
                        )

                        MoreScreenEvent.OnFavoriteExpertClick -> navigation.pushNew(
                            FavoriteScreenConfig
                        )

                        MoreScreenEvent.OnLoginClick -> navigation.pushNew(
                            LoginPage
                        )
                    }
                },
                favoriteTabEvent = { event ->
                    when (event) {
                        FavoriteTabEvent.OnBackClick -> {
//                            bottomNavigation.select(0)
                        }

                        is FavoriteTabEvent.OnCallConsultation -> onAuthenticationValidate {
                            dialogNavigation.activate(
                                CallDurationDialog(
                                    isEmergencyCall = event.isEmergency,
                                    expertInfo = event.commonExpertInfo
                                )
                            )
                        }

                        is FavoriteTabEvent.OnCardClick -> {
                            event.data.expertId?.let {
                                ExpertDetailsPage(
                                    it
                                )
                            }
                                ?.let {
                                    navigation.pushNew(
                                        it
                                    )
                                }
                        }

                        is FavoriteTabEvent.OnChatConsultation -> onAuthenticationValidate {
                            dialogNavigation.activate(
                                ChatDurationDialog(
                                    isEmergencyChat = event.isEmergency,
                                    expertInfo = event.commonExpertInfo
                                )
                            )
                        }

                        is FavoriteTabEvent.OnQueueConsultation -> onAuthenticationValidate {
                            dialogNavigation.activate(
                                QueueDialogConfig(
                                    expertInfo = event.commonExpertInfo,
                                    type = event.type.name,
                                    isChatAvailable = event.isChatAvailable,
                                    isCallAvailable = event.isCallAvailable,
                                    waitingTime = event.waitingTime.toString(),
                                    queNumber = event.queueNumber,
                                    onQueueJoined = event.onQueueChatConsJoined
                                )
                            )
                        }

                        is FavoriteTabEvent.OnQueueStatus -> dialogNavigation.activate(
                            QueueStatusDialogConfig(
                                expertInfo = event.commonExpertInfo,
                                onQueueJoined = event.onQueueChatConsJoined
                            )
                        )

                        is FavoriteTabEvent.OnLoginClick -> {
                            navigation.pushNew(Configuration.LoginPage)
                        }
                    }
                },
                onPostClick = { id ->
                    navigation.pushNew(
                        PostDetailsConfig(
                            id
                        )
                    )
                },
                onRegisterButtonClick = { slug ->
                    navigation.pushNew(
                        CoursePageConfig(
                            slug
                        )
                    )
                })
        )
    }

}